<template>
  <div cols="auto" style="max-width: 100%; min-height: 52px; height: 52px; max-height: 52px" class="panel--top">
    <v-row no-gutters class="justify-center align-center py-1 pr-2 fill-height flex-nowrap">
      <v-col cols="auto" class="flex-grow-1">
        <v-row no-gutters class="flex-nowrap" align="center">
          <v-col cols="auto" class="px-2 d-flex align-center" style="height: auto">
            <img ref="logo" style="max-height: 32px; cursor: pointer" :src="url" contain />
          </v-col>
          <v-col class="d-flex justify-center">
            <v-row no-gutters>
              <v-col cols="auto" class="d-flex justify-center">
                <v-subheader class="pa-0 text--primary tw:text-base tw:items-center" style="height: auto">
                  {{ appName }}
                </v-subheader>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <slot name="content.prepend" />
      <v-spacer />
      <v-col cols="auto">
        <v-menu bottom offset-y>
          <template #activator="{ on }">
            <v-row no-gutters v-on="on" class="tw:cursor-pointer">
              <v-col cols="auto">
                <user-avatar id="current" />
              </v-col>
            </v-row>
          </template>
          <v-row no-gutters style="background-color: white; min-width: 250px">
            <v-col cols="12" class="text-body-2">
              <v-row no-gutters align="center" class="pa-4 border-bottom">
                <v-col cols="auto" class="pr-2"> <user-avatar id="current" /> </v-col>
                <v-col cols="auto">
                  <v-row no-gutters> {{ currentUser.name }} </v-row>
                  <v-row no-gutters class="tw:text-xs italic--text"> {{ currentUser.email }} </v-row>
                </v-col>
              </v-row>
              <v-row
                v-for="(setting, idx) of userSettings"
                :key="idx"
                no-gutters
                align="center"
                :class="`px-4 py-3 tw:hover:bg-gray-100 tw:hover:cursor-pointer ${setting.color}--text`"
                @click="handleUserSetting(setting.value)"
              >
                <v-col cols="auto" class="pr-1">
                  <v-icon :color="setting.color" size="20" class="pr-1">{{ setting.icon }}</v-icon>
                </v-col>
                <v-col cols="auto">{{ setting.text }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-menu>
      </v-col>
    </v-row>
    <user-settings-dialog :is-visible.sync="isUserSettingsDialogVisible" v-if="isUserSettingsDialogVisible !== null" />
    <dev-info-dialog :is-visible.sync="isDevInfoDialogVisible" v-if="isDevInfoDialogVisible !== null" />
  </div>
</template>
<script>
import { call, get } from 'vuex-pathify';
import logo from '@/mixins/logo';

import UserAvatar from '@/components/UserAvatar';
import UserSettingsDialog from '@/components/UserSettingsDialog';

export default {
  name: 'NavbarPanel',
  components: {
    UserAvatar,
    UserSettingsDialog,
    DevInfoDialog: () => import('@/components/DevInfoDialog'),
  },
  mixins: [logo],
  computed: {
    appName: get('admin/settingsValues@app_name'),
    currentUser: get('users/currentUser'),
    userSettings() {
      return [
        { value: 'devInfo', text: this.$i18n.t('sider.devInfo'), icon: 'mdi-help-circle' },
        { value: 'settings', text: this.$i18n.t('sider.settings'), icon: 'mdi-cog' },
        { value: 'logout', text: this.$i18n.t('sider.logout'), icon: 'mdi-logout', color: 'error' },
      ];
    },
  },
  data: () => ({
    isUserSettingsDialogVisible: null,
    isDevInfoDialogVisible: null,
    url: `${import.meta.env.VUE_APP_API_URL}/settings/logo`,
  }),
  methods: {
    createGtagEvent: call('gtag/createEvent'),
    logout: call('authentication/logout'),
    handleUserSetting(value) {
      switch (value) {
        case 'settings': {
          this.isUserSettingsDialogVisible = true;
          break;
        }
        case 'logout': {
          this.logoutHandler();
          break;
        }
        case 'devInfo': {
          this.isDevInfoDialogVisible = true;
          break;
        }
      }
    },
    async logoutHandler() {
      this.$root.$emit('socket.close', { name: 'default' });
      this.createGtagEvent({
        action: 'logout',
        extra_params: {
          method: 'private',
          user: this.currentUser.name,
        },
      });
      await this.logout();
      this.$router.push({ name: 'login', query: { refresh_app_data: true } });
    },
  },
};
</script>
<style lang="scss" scoped>
.border-bottom {
  @include border(bottom, 1px);
}
</style>
